/* global process */
import {
    addListError,
    addProducts,
    addToastrNotification,
    changeQuantity,
    editListName,
    removeProduct,
    saveStores,
    saveZips,
    setArtNbrError,
    setCollectError,
    setDeliverError,
    setFormProcessing,
    setLoading,
    setRemovingItems,
    setStores,
    updateAppLoadingFlag,
    updateLoadingFlag,
    updateProduct,
    updateProductStock,
    updateShoppingListNoItems,
    updateShoppingLists,
    setAuthenticationFlag,
} from './favourites.actions';
import { LIST_TYPE } from '../constants';


// #region Helpers
import updateHeaderBadge from 'helpers/CartBadge';
import { generateProduct, formatProducts } from 'helpers/Product';
import Authorize from 'helpers/Auth';
import { createInstance, activateExperiments, generalExperiments } from 'helpers/Optimizely';
import APIFactory from 'helpers/ApiFactory';
import { getText } from 'helpers/i18n';

// #endregion Helpers

// #region Api
import { fetchProductData } from 'api/ItemComm';
// #endregion Api

// #region Packages
import IntlPolyfill from 'lean-intl';
import HmacSHA1 from 'crypto-js/hmac-sha1';
// #endregion Packages

// #region ClickCollectActions
export const getCollectionStores = () => {
    return (dispatch) => {
        fetch(window.Checkout.settings.clickcollect.store_url)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                return null;
            })
            .then((data) => {
                dispatch(saveStores(data));
                return null;
            })
            .catch((error) => {
                console.error(error); // eslint-disable-line no-console
            });
    };
};
export const placeCollectOrder = (store, products) => {
    return (dispatch) => {
        const payload = {
            selectedService: 'fetchlocation',
            customerView: document.documentElement.clientWidth > 1024 ? 'desktop' : 'mobile',
            locale: window.Checkout.settings.language_code + '_' + window.Checkout.settings.country_code.toUpperCase(),
            selectedServiceValue: store,
            slId: '1241241241',
            articles: [],
        };

        dispatch(setFormProcessing('clickCollect', true));

        for (const product in products) {
            payload.articles.push(
                {
                    articleNo: products[product].articleType === 'SPR' ? 'S' + products[product].articleNumber : products[product].articleNumber,
                    count: products[product].quantity,
                }
            );
        }
        const hmac = HmacSHA1(JSON.stringify(payload), 'G6XxMY7n').toString();
        const headers = new Headers({
            'Content-type': 'application/x-www-form-urlencoded',
        });
        const backUrl = window.location.href.includes('//localhost') ? 'http://www.ikea.com/no/no/mcommerce/shoppingcart' : window.location.href;

        fetch(window.Checkout.settings.clickcollect.payload_url, {
            method: 'post',
            headers: headers,
            body: 'payload=' + JSON.stringify(payload) + '&backUrl=' + backUrl + '&hmac=' + hmac,
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                return null;
            })
            .then((data) => {
                if (data.status === 'OK') {
                    window.Checkout.analytics.logEcommerceEvent({
                        name: 'set_checkout_option',
                        params: {
                            checkout_step: 1,
                            checkout_option: 'fulfilment type - store ' + store,
                        },
                    });
                    window.location = data.target;
                } else {
                    dispatch(setFormProcessing('clickCollect', false));
                    dispatch(setFormProcessing('collectSubmit', false));
                    dispatch(setCollectError(data.code));
                }
                return null;
            })
            .catch((error) => {
                dispatch(setFormProcessing('clickCollect', false));
                console.error(error); // eslint-disable-line no-console
            });
    };
};
// #endregion ClickCollectActions

// #region ClickDeliveryActions
export const getCollectionZips = () => {
    return (dispatch) => {
        return fetch(window.Checkout.settings.clickdeliver.zips_url)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                return null;
            })
            .then((data) => {
                dispatch(saveZips(data));
                return null;
            })
            .catch((error) => {
                console.error(error); // eslint-disable-line no-console
            });
    };
};
export const placeDeliverOrder = (zip, products) => {
    return (dispatch) => {
        window.Checkout.analytics.logEcommerceEvent({
            name: 'set_checkout_option',
            params: {
                checkout_step: 1,
                checkout_option: 'delivery method - home delivery',
            },
        });

        dispatch(setFormProcessing('clickDeliver', true));

        const payload = {
            selectedService: 'zip',
            selectedServiceValue: zip,
            slId: '1241241241',
            articles: [],
            locale: window.Checkout.settings.language_code + '_' + window.Checkout.settings.country_code.toUpperCase(),
            customerView: document.documentElement.clientWidth > 1024 ? 'desktop' : 'mobile',
        };
        for (const product in products) {
            payload.articles.push(
                {
                    articleNo: products[product].articleType === 'SPR' ? 'S' + products[product].articleNumber : products[product].articleNumber,
                    count: products[product].quantity,
                }
            );
        }
        const hmac = HmacSHA1(JSON.stringify(payload), 'G6XxMY7n').toString();
        const headers = new Headers({
            'Content-type': 'application/x-www-form-urlencoded',
        });
        const backUrl = window.location.href.includes('//localhost') ? 'http://www.ikea.com/no/no/mcommerce/shoppingcart' : window.location.href;

        return fetch(window.Checkout.settings.clickcollect.payload_url, {
            method: 'post',
            headers: headers,
            body: 'payload=' + JSON.stringify(payload) + '&backUrl=' + backUrl + '&hmac=' + hmac,
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                return null;
            })
            .then((data) => {
                if (data.status === 'OK') {
                    window.location = data.target;
                } else {
                    dispatch(setFormProcessing('clickDeliver', false));
                    dispatch(setDeliverError(data.code));
                }
                return null;
            })
            .catch((error) => {
                dispatch(setFormProcessing('clickDeliver', false));
                console.error(error); // eslint-disable-line no-console
            });
    };
};
// #endregion ClickDeliverActions

// #region ShoppingBagActions
export const syncShoppingBagItems = (previousProductsIds, currentProductsIds) => {
    return dispatch => {
        if (previousProductsIds) {
            // Check if there are articles stored in redux that are not in sync with the current cart.
            // If so, remove them from redux.
            const outdatedProducts = previousProductsIds.filter(item => !currentProductsIds.includes(item));
            if (outdatedProducts.length > 0) {
                outdatedProducts.forEach(product => dispatch(removeProduct(product, 'onlineshoppingcart')));
            }
        }
    };
};

export const addToCart = (items) => {
    return dispatch => {
        if (!window.Checkout.settings.checkout.enable) {
            updateHeaderBadge();
            return true;
        }

        dispatch(setFormProcessing('addToCart', true));
        dispatch(setArtNbrError(false));
        return window.Checkout.cartApi
            .withParameters({ items })
            .run('postItemsToCart')
            .then(result => {
                window.Checkout.analytics.logEcommerceEvent({
                    name: 'add_to_cart',
                    params: { items: items.map(({ itemNo, quantity }) => ({ id: itemNo, quantity })) },
                });
                if (window.Checkout.settings.enable_behtar_analytics && window.behtar) {
                    window.behtar.pushEvent('order', 'shoppingbag');
                }
                if (result) {
                    updateHeaderBadge();
                }

                dispatch(setFormProcessing('addToCart', false));
                return true;
            })
            .catch(err => {
                dispatch(setFormProcessing('addToCart', false));
                dispatch(setArtNbrError('ADD_ITEM_ERROR'));
                dispatch(addToastrNotification('ADD_ITEM_ERROR', 'error', null));
                console.error(err); // eslint-disable-line no-console
            });
    };
};
// #endregion ShoppingBagActions

// #region ProductActions
export const addProductToBag = (products, toListType, showToastrNotification) => {
    return (dispatch) => {
        dispatch(addProductToList(products, 'onlineshoppingcart', toListType, showToastrNotification));
    };
};

export const addProductToList = (products, toListType, fromList, showToastrNotification) => {
    return async(dispatch) => {
        let result = true;
        const productIds = products.map(product => product.ItemNo.$);

        if (toListType === 'onlineshoppingcart' && window.Checkout.settings.checkout.enable) {
            const items = products.map(product => ({ itemNo: product.ItemNo.$, quantity: product.ItemQty.$ }));
            result = await dispatch(addToCart(items, fromList));
        }
        if (fromList) {
            for (let i = 0; i < products.length; i++) {
                dispatch(setLoading(products[i].ItemNo.$, false, fromList));
            }
        }
        const success = await result;
        if (success && showToastrNotification) {
            dispatch(addToastrNotification('PRODUCT_ADDED', 'success', productIds));
        }

        // Processing state for ‘Add all items to bag’
        dispatch(setFormProcessing('movingProducts', false));
        return result;
    };
};

export const getListProducts = (list, listType) => {
    return (dispatch) => {
        return window.Checkout.shoppingListApi
            .withParameters({ list, listType })
            .run('getProductList')
            .then(data => {
                let rawProducts = {};
                if (typeof data.ShoppingBag.ShoppingBagSectionList.ShoppingBagSection.ShoppingBagItemList.ShoppingBagItem !== 'undefined') {
                    rawProducts = data.ShoppingBag.ShoppingBagSectionList.ShoppingBagSection.ShoppingBagItemList.ShoppingBagItem;
                }

                dispatch(addProducts(formatProducts(rawProducts), listType));
                dispatch(updateLoadingFlag(false));
                return null;
            })
            .catch((error) => {
                dispatch(addToastrNotification('GET_PRODUCT_LIST_ERROR'));
                console.error(error); // eslint-disable-line no-console
            });
    };
};

export const getProductData = (id, type, quantity, listType) => dispatch => {
    fetchProductData(id, type, window.Checkout.settings.shoppinglist)
        .then((response) => {
            if (response !== null) {
                const product = response.data ? response.data[0] : response;
                dispatch(updateProduct(generateProduct(product, listType), quantity, listType));
            }
            return null;
        })
        .catch((error) => {
            dispatch(addToastrNotification('GET_PRODUCT_DATA_ERROR'));
            console.error(error); // eslint-disable-line no-console
        });
};

export const getProductStock = (productData, store, listType) => {
    return (dispatch) => {
        const headers = new Headers({
            'Accept': 'application/vnd.ikea.iows+json;version=1.0',
            'Contract': window.Checkout.settings.shoppinglist.contract,
            'Consumer': window.Checkout.settings.shoppinglist.consumer,
        });

        const init = {
            method: 'GET',
            headers: headers,
            mode: 'cors',
        };

        const request = new Request(window.Checkout.settings.shoppinglist.endpoint + '/retail/iows/' + window.Checkout.settings.locale_url + '/stores/' + store + '/availability/' + productData.articleType + '/' + productData.articleNumber, init);
        fetch(request)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(response.status);
            })
            .then(data => {
                if (data.StockAvailability && data.StockAvailability.RetailItemAvailability && data.StockAvailability.RetailItemAvailability.InStockProbabilityCode) {
                    window.Checkout.analytics.logEvent('stock_check', data.StockAvailability.RetailItemAvailability.InStockProbabilityCode.$.toLowerCase(), window.Checkout.analytics.productId(productData));
                }
                dispatch(updateProductStock(productData.articleNumber, data.StockAvailability.RetailItemAvailability, data.StockAvailability.AvailableStockForecastList, listType));
                return null;
            })
            .catch(error => {
                window.Checkout.analytics.logEvent('stock_check', 'error', window.Checkout.analytics.productId(productData));
                dispatch(addToastrNotification('GET_PRODUCT_STOCK_ERROR'));
                console.error(error); // eslint-disable-line no-console
            });
    };
};

export const moveProduct = (articleData, toList, selectedList, listType, showToastr = false, removeFromCart = true) => {
    return (dispatch) => {
        // Display loader
        dispatch(setLoading(articleData.articleNumber, true, listType));

        // Adds product in new shoppinglist via API
        const product = [{
            ProductName: { $: articleData.productName },
            ItemType: { $: articleData.articleType },
            ItemNo: { $: articleData.articleNumber.toString() },
            ItemQty: { $: articleData.quantity },
            ArticleData: articleData,
        }];
        const toListType = (listType === 'onlineshoppingcart') ? LIST_TYPE : listType;

        const result = dispatch(addProductToList(product, toListType, false, false));
        // addProductToList will return null for older implementation, promise for where we need to catch errors.
        if (result !== true) {
            result
                .then(() => {
                    const promise = removeFromCart ? dispatch(saveRemoval(articleData, selectedList, listType)) : Promise.resolve(true);
                    if (showToastr) dispatch(addToastrNotification('PRODUCT_ADDED_TO_LIST', 'success', [articleData]));
                    dispatch(moveProductToOtherShoppinglist(articleData, toListType, toList, articleData.quantity, articleData));
                    return promise;
                })
                .catch((error) => {
                    console.error(error); // eslint-disable-line no-console
                });
        } else {
            if (removeFromCart) dispatch(saveRemoval(articleData, selectedList, listType));
            if (showToastr) dispatch(addToastrNotification('PRODUCT_ADDED_TO_LIST', 'success', [articleData]));
        }

        // Hide loader
        dispatch(setLoading(articleData.articleNumber, false, listType));
    };
};

export const moveProductToOtherShoppinglist = (productData, listType, selectedList, quantityDelta) => {
    return (dispatch) => {
        return window.Checkout.shoppingListApi
            .withParameters({ productData, listType, selectedList, quantityDelta })
            .run('changeQuantity')
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error(response.status);
            })
            .then(() => {
                return dispatch(updateShoppingListNoItems(selectedList, quantityDelta));
            })
            .catch(error => {
                dispatch(addToastrNotification('SAVE_QUANTITY_CHANGE_ERROR'));
                console.error(error); // eslint-disable-line no-console
            });
    };
};

export const saveQuantityChange = (productData, listType, selectedList, quantity, quantityDelta) => {
    return (dispatch) => {
        return window.Checkout.shoppingListApi
            .withParameters({ productData, listType, selectedList, quantityDelta })
            .run('changeQuantity')
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error(response.status);
            })
            .then(() => {
                dispatch(changeQuantity(productData.articleNumber, quantity, listType));
                dispatch(updateShoppingListNoItems(selectedList, quantityDelta));
                dispatch(setLoading(productData.articleNumber, false, listType));

                return null;
            })
            .then(() => {
                if (quantityDelta !== 0) {
                    const logAction = quantityDelta > 0 ? 'increase_amount' : 'decrease_amount';
                    const logLabel = listType === 'onlineshoppingcart' ? 'cart' : 'wishlist';
                    window.Checkout.analytics.logEvent('checkout_actions', logAction, logLabel);
                }
                return dispatch(setLoading(productData.articleNumber, false, listType));
            })
            .catch(error => {
                dispatch(addToastrNotification('SAVE_QUANTITY_CHANGE_ERROR'));
                console.error(error); // eslint-disable-line no-console
            });
    };
};

export const _deleteItem = (articleData, list, listType) => {
    return window.Checkout.shoppingListApi
        .withParameters({ articleData, list, listType })
        .run('deleteItem')
        .then(response => {
            return response;
        });
};

export const saveRemoval = (articleData, list, listType) => {
    return async(dispatch) => {
        dispatch(setRemovingItems(true));

        return window.Checkout.auth.getSessionContext()
            .then(() => {
                return _deleteItem(articleData, list, listType);
            })
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                return null;
            })
            .then(() => {
                dispatch(removeProduct(articleData.articleNumber, listType));
                dispatch(setRemovingItems(false));
                if (listType === LIST_TYPE) {
                    window.Checkout.analytics.logEvent('ecommerce', 'remove_from_wishlist', window.Checkout.analytics.productId(articleData));
                    dispatch(updateShoppingListNoItems(list, -articleData.quantity));
                }
                return null;
            })
            .catch((error) => {
                dispatch(addToastrNotification('REMOVE_FROM_CART_ERROR'));
                console.error(error); // eslint-disable-line no-console
            });
    };
};
// #endregion ProductActions

// #region ShoppingListActions
export const createList = (name, listType, products = [], shouldStopLoading, showToastrNotification, createdFromListType) => {
    return async(dispatch) => {
        return await window.Checkout.shoppingListApi
            .withParameters({ name, listType, products })
            .run('createList')
            .then(data => {
                // API error treatment
                if (typeof data.ErrorList !== 'undefined') {
                    if (data.ErrorList.Error.ErrorCode.$ === 50101) {
                        dispatch(addListError(getText('new_list_modal_err_maximum_lists')));
                        return null;
                    }
                }
                if (listType === LIST_TYPE) {
                    dispatch(getShoppingLists());
                    dispatch(addListError());
                }
                for (let i = 0; i < products.length; i++) {
                    if (shouldStopLoading) {
                        dispatch(setLoading(products[i].ItemNo.$, false, createdFromListType || listType));
                    }
                    if (showToastrNotification) {
                        dispatch(addToastrNotification('PRODUCT_ADDED', 'success', [products[i].ItemNo.$]));
                    }
                }
                if (listType === 'onlineshoppingcart' && data.ShoppingBag && data.ShoppingBag.BagId) {
                    return data.ShoppingBag.BagId.$;
                }
                return null;
            });
    };
};

export const getShoppingLists = (selectedList, ignoreLoadingFlag = false) => {
    return async(dispatch) => {
        dispatch(setFormProcessing('getShoppingLists', true));
        return await window.Checkout.shoppingListApi
            .withParameters({ selectedList, ignoreLoadingFlag })
            .run('getShoppingLists')
            .then(response => {
                dispatch(setFormProcessing('getShoppingLists', false));
                dispatch(setFormProcessing('fetchedShoppingLists', true));
                if (!response) {
                    dispatch(createList(getText('no_shoppinglist_default_name'), 'onlineshoppinglist'));
                    return null;
                }
                dispatch(updateShoppingLists(response.lists, response.selectedListId));
                return response.selectedListId;
            }).catch(error => {
                dispatch(setFormProcessing('getShoppingLists', false));
                dispatch(setFormProcessing('fetchedShoppingLists', true));
                if (!ignoreLoadingFlag) {
                    dispatch(updateLoadingFlag(false));
                }
                dispatch(updateShoppingLists({}, null));
                console.warn(error); // eslint-disable-line no-console
            });
    };
};

export const deleteShoppingList = (listId) => {
    return async(dispatch) => {
        return await window.Checkout.shoppingListApi
            .withParameters({ listId })
            .run('deleteShoppingList')
            .then(() => {
                return dispatch(getShoppingLists());
            }).catch(error => {
                console.error(error); // eslint-disable-line no-console
            });
    };
};

export const editShoppingListName = (listId, listType, newName) => {
    return async(dispatch) => {
        return await window.Checkout.shoppingListApi
            .withParameters({ listId, listType, newName })
            .run('editShoppingListName')
            .then((data) => {
                // API error treatment
                if (typeof data.ErrorList !== 'undefined') {
                    return null;
                }
                dispatch(editListName(listId, newName));
                return null;
            });
    };
};

export const getShoppingList = listId => {
    return async() => {
        return await window.Checkout.shoppingListApi
            .withParameters({ listId })
            .run('getShoppingList')
            .then(data => {
                return data;
            }).catch(error => {
                console.error(error); // eslint-disable-line no-console
            });
    };
};
// #endregion ShoppingListActions

// #region StoreActions
export const getStores = () => {
    return (dispatch) => {
        const headers = new Headers({
            'Accept': 'application/vnd.ikea.iows+json;version=2.0',
            'Contract': window.Checkout.settings.shoppinglist.contract,
            'Consumer': window.Checkout.settings.shoppinglist.consumer,
        });

        const init = {
            method: 'GET',
            headers: headers,
            mode: 'cors',
        };

        const request = new Request(window.Checkout.settings.shoppinglist.endpoint + '/retail/irms/' + window.Checkout.settings.locale_url + '/stores', init);

        return fetch(request)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                return null;
            }).then(data => {
                const stores = [
                    {
                        name: getText('select_store_label'),
                        value: 0,
                    },
                ];

                const storedata = data?.StoreRefList?.StoreRef ?? data;
                if (storedata.length) {
                    for (let i = 0; i < storedata.length; i++) {
                        if (!window.Checkout.settings.shoppinglist.excludedStores
                            .includes(getStoreName(storedata[i]))) {
                            stores.push({
                                name: getStoreName(storedata[i]),
                                value: getStoreNo(storedata[i]),
                            });
                        }
                    }
                } else {
                    stores.push({
                        name: getStoreName(storedata),
                        value: getStoreNo(storedata),
                    });
                }


                return dispatch(setStores(stores));
            })
            .catch((error) => {
                dispatch(addToastrNotification('GET_STORES_ERROR'));
                console.error(error); // eslint-disable-line no-console
            });
    };
};
const getStoreName = data => data?.StoreName?.$ ?? data?.storeName;
const getStoreNo = data => data?.StoreNo?.$ ?? data?.storeNo;
// #endregion StoreActions

// #region AppActions
export const fetchInitData = (country, language) => {
    return async(dispatch) => {
        const readyApp = () => {
            // Bypass the checkout enable flag. Used to test in production without enabling for customers
            document.cookie.split(';').map((item) => {
                if (item.trim().indexOf('forceEnableCheckout=') === 0) {
                    window.Checkout.settings.checkout.enable = true;
                }
                if (item.trim().indexOf('forceEnableECheckout=') === 0) {
                    window.Checkout.settings.express_checkout.enable = true;
                }
                return null;
            });

            dispatch(updateAppLoadingFlag(false));
            dispatch(setAuthenticationFlag(window.Checkout.auth.isLoggedIn()));
        };

        if (window.optimizelySdk) {
            if (window.Checkout.optimizely && !window.Checkout.optimizely.sdk) {
                window.Checkout.optimizely.sdk = await createInstance(window.Checkout.optimizely.datafile);
            } else if (!window.Checkout.optimizely) {
                window.Checkout.optimizely = {};
                window.Checkout.optimizely.sdk = await createInstance();
            }
        }

        // If we’ve already got text and settings through ESI we can skip the dynamic load
        if (window.Checkout && window.Checkout.text && window.Checkout.settings) {
            // Use Intl polyfill if no support for Intl.NumberFormatter.formatToParts
            if ((!window.Intl || !window.Intl.NumberFormat.prototype.formatToParts) && window.Checkout.intlData) {
                IntlPolyfill.__addLocaleData(window.Checkout.intlData);
                window.Intl = IntlPolyfill;
            }

            await loadAdapters();

            return window.Checkout.auth.getSessionContext()
                .then(userId => {
                    if (!window.Checkout.optimizely || !window.Checkout.optimizely.sdk) {
                        return;
                    }

                    activateExperiments(country.toUpperCase(), userId, generalExperiments);
                    return;
                })
                .then(() => {
                    readyApp();
                    return;
                })
                .catch((error) => {
                    console.error(error); // eslint-disable-line no-console
                });
        }

        // Check if running on development environment and set path to data files since
        // production and development environment uses different paths.
        let dataPath = '/' + country + '/' + language + '/checkout/data/';
        let envDataPath = '/' + country + '/' + language + '/checkout/data/env/' + process.env.NODE_ENV + '/';
        if (!window.location.href.includes(['ikeadt.com', 'ikea.com'])) {
            dataPath = '/data/';
            envDataPath = '/data/env/development/';
        }

        return Promise.all([
            fetch(dataPath + 'master_settings.json'),
            fetch(dataPath + country + '_' + language.toUpperCase() + '_settings.json'),
            fetch(dataPath + 'phrase/' + language + '-' + country.toUpperCase() + '.json'),
            fetch(dataPath + 'intl/' + language + '-' + country.toUpperCase() + '.json'),
            fetch(envDataPath + country + '_' + language.toUpperCase() + '_settings.json', {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            }),
        ])
            .then(responseResults => {
                if (responseResults[0].ok && responseResults[1].ok && responseResults[2].ok && responseResults[3].ok) {
                    const response = [
                        responseResults[0].json(), // master settings
                        responseResults[1].json(), // market settings
                        responseResults[2].json(), // locale parameters
                        responseResults[3].json(), // internationale parameters
                    ];
                    if (responseResults[4].ok) {
                        response.push(responseResults[4].json()); // environment specific market settings
                    }
                    return Promise.all(response);
                }
                throw new Error('500 - Unable to load setting files.');
            })
            .then(async results => {
                window.Checkout = window.Checkout || {};

                // Load master settings, and replace with market settings
                let appSettings = {
                    ...results[0],
                    ...results[1],
                };

                // If environment specific settings available, load them as replacement
                if (results[4]) {
                    appSettings = {
                        ...appSettings,
                        ...results[4],
                    };
                }
                window.Checkout.settings = window.Proxy ? new Proxy(appSettings, window.Checkout.proxy.data) : appSettings;
                window.Checkout.text = window.Proxy ? new Proxy(results[2], window.Checkout.proxy.data) : results[2];

                // Use Intl polyfill if no support for Intl.NumberFormatter.formatToParts
                if (!window.Intl || !window.Intl.NumberFormat.prototype.formatToParts) {
                    IntlPolyfill.__addLocaleData(results[3]);
                    window.Intl = IntlPolyfill;
                }

                await loadAdapters();

                return window.Checkout.auth.getSessionContext();
            })
            .then(userId => {
                if (!window.Checkout.optimizely || !window.Checkout.optimizely.sdk) {
                    return;
                }

                activateExperiments(country.toUpperCase(), userId, generalExperiments);
                return;
            })
            .then(() => {
                readyApp();
                return null;
            })
            .catch(error => {
                console.error(error); // eslint-disable-line no-console
            });
    };
};

const loadAdapter = async(apiType, adapterKey, setting = {}) => {
    if (window.Checkout[adapterKey] || setting.enable === false) return;
    const apiAdapter = `${apiType}/${setting.adapter}`;

    try {
        const { default: adapter } = await import(`api/${apiAdapter}`);
        window.Checkout[adapterKey] = new APIFactory().setAdapter(adapter);
    } catch (error) {
        console.error(`FAILED: Loading adapter ${apiAdapter}`, error); // eslint-disable-line no-console
    }
};

export const loadAdapters = async() => {
    await Promise.all([
        loadAdapter('Cart', 'cartApi', window.Checkout.settings.cartApi),
        loadAdapter('Shoppinglist', 'shoppingListApi', window.Checkout.settings.shoppinglist),
    ]);

    // Initialize authorize module to be used sitewide.
    if (!window.Checkout.auth) {
        window.Checkout.auth = new Authorize(window.Checkout.shoppingListApi); // Or is it window.Checkout.api?
    }
};
// #endregion AppActions
